import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const res = await api.post("/newsletter", { email });
      toast.success(res.data.message);
      setEmail("");
    } catch {
      toast.error("Iscrizione non riuscita. Riprova.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer data-testid="main-footer" className="relative z-10 bg-[#0A0A0A] border-t border-white/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <span className="inline-flex bg-white rounded-md px-3 py-2 mb-5">
            <img src="https://customer-assets-jai6qajn.emergentagent.net/job_premium-coach-16/artifacts/dcxb31ag_541836134_1192345226267593_2562402301226683083_n.jpg" alt="MS Coach — Mirko Scravaglieri" className="h-9 w-auto" />
          </span>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            Mental coach. Accompagno persone e aziende a sbloccare il proprio potenziale attraverso percorsi di crescita concreti, umani ed eleganti.
          </p>
          <div className="flex gap-4 mt-6">
            {[Instagram, Facebook, Linkedin, Mail].map((Icon, i) => (
              <a key={i} href="#" data-testid={`footer-social-${i}`} className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center text-zinc-300 hover:border-[#C19A5B] hover:text-[#C19A5B] transition-colors">
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <p className="eyebrow mb-4">Naviga</p>
          <ul className="space-y-2 text-zinc-400">
            <li><Link to="/chi-sono" className="hover:text-[#C19A5B]">Chi sono</Link></li>
            <li><Link to="/servizi" className="hover:text-[#C19A5B]">Servizi</Link></li>
            <li><Link to="/eventi" className="hover:text-[#C19A5B]">Eventi</Link></li>
            <li><Link to="/blog" className="hover:text-[#C19A5B]">Blog</Link></li>
            <li><Link to="/contatti" className="hover:text-[#C19A5B]">Contatti</Link></li>
          </ul>
        </div>

        <div>
          <p className="eyebrow mb-4">Newsletter</p>
          <p className="text-zinc-400 text-sm mb-4">Ricevi spunti di crescita personale e professionale.</p>
          <form onSubmit={subscribe} className="flex flex-col gap-3" data-testid="newsletter-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="La tua email"
              data-testid="newsletter-email"
              className="bg-[#121212] border border-[#27272A] rounded-md px-4 py-2.5 text-sm focus:border-[#C19A5B] outline-none"
              required
            />
            <button type="submit" disabled={busy} data-testid="newsletter-submit" className="rounded-md bg-[#C19A5B] text-black text-sm font-semibold px-4 py-2.5 hover:bg-[#D4AF37] transition-colors disabled:opacity-60">
              {busy ? "..." : "Iscriviti"}
            </button>
          </form>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-sm text-zinc-500">
        <p>© {new Date().getFullYear()} Mirko Scravaglieri. Tutti i diritti riservati.</p>
        <Link to="/login" data-testid="footer-admin-link" className="hover:text-[#C19A5B]">Area riservata</Link>
      </div>
    </footer>
  );
};
